import { Create, SimpleForm, useCreate, useRedirect, useNotify } from "react-admin";
import { useMemo } from "react";
import SaveForm from "./SaveForm";
import { REGULAR } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import CustomToolbar from "../components/CustomToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateRegularCampaign = () => {
  const location = useLocation();
  const isClone = location?.state?.isClone;
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const [isSaving, setIsSaving] = useState(false);

  const defaultValues = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const source = params.get("source");
    if (source) {
      try {
        return JSON.parse(decodeURIComponent(source));
      } catch (e) {
        console.error("Invalid source:", e);
      }
    }
    return {};
  }, [location.search]);

  const campaignSave = data => {
    setIsSaving(true);
    if (data.rooms && data.rooms.length > 0) {
      data.rooms = data.rooms.map((room, roomIndex) => ({
        ...room,
        priority: ++roomIndex,
      }));
    }

    if (data.exams && data.exams.length > 0) {
      data.exams = data.exams.map(exam => {
        if (!exam.examDays) {
          exam.examDays = [];
        }
        exam.examDays = exam.examDays.map(examDay => {
          const examOnlyDate = examDay.examStartTimestamp?.split("T")[0];
          if (examDay.timeSlots && examDay.timeSlots.length > 0) {
            examDay.timeSlots = examDay.timeSlots.map(timeSlot => {
              timeSlot.startTime = timeSlot.startTime ? examOnlyDate + "T" + timeSlot.startTime.split("T")[1] : null;
              timeSlot.endTime = timeSlot.endTime ? examOnlyDate + "T" + timeSlot.endTime.split("T")[1] : null;
              timeSlot.breakHourStart = timeSlot.breakHourStart
                ? examOnlyDate + "T" + timeSlot.breakHourStart.split("T")[1]
                : null;
              timeSlot.breakHourEnd = timeSlot.breakHourEnd
                ? examOnlyDate + "T" + timeSlot.breakHourEnd.split("T")[1]
                : null;
              if (timeSlot.rooms && timeSlot.rooms.length > 0 && timeSlot.isRoomsChanges) {
                timeSlot.rooms = timeSlot.rooms.map((room, roomIndex) => ({
                  ...room,
                  priority: ++roomIndex,
                }));
              }
              return timeSlot;
            });
          }
          return examDay;
        });
        return exam;
      });
    }

    create(
      candidateRequests.campaignByType(REGULAR),
      { data },
      {
        onSuccess: () => {
          redirect("list", candidateRequests.campaignByType(REGULAR));
        },
        onError: error => {
          notify(`Error: ${error.message || "Грешка при създаване на редовна кампания"}`, { type: "error" });
          setIsSaving(false);
        },
      },
    );
  };

  return (
    <Create
      title={isClone ? "Клониране на редовна кампания" : "Създаване на редовна кампания"}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm
        onSubmit={campaignSave}
        defaultValues={defaultValues}
        toolbar={<CustomToolbar isSaving={isSaving} />}
      >
        <SaveForm
          isCreate
          isClone={isClone}
        />
      </SimpleForm>
    </Create>
  );
};
export default CreateRegularCampaign;
